
export default {
  computed: {
    show() {
      return this.$globalData.notification.show;
    },
    message() {
      return this.$globalData.notification.message;
    },
    type() {
      return this.$globalData.notification.type;
    }
  },
  methods: {
    hide() {
      this.$globalMethod.hideNotification();
    }
  }
};
